import React, { ReactNode } from 'react';

import { useToggle } from 'react-use';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { Collapse } from '@mui/material';

import classes from './Accordion.module.scss';

export type AccordionProps = {
  title: string;
  children: ReactNode;
  className?: string;
};

const Accordion = ({ title, children, className }: AccordionProps) => {
  const [isOpen, toggleOpen] = useToggle(false);

  const Icon = isOpen ? (
    <RemoveRoundedIcon color="primary" />
  ) : (
    <AddRoundedIcon color="primary" />
  );

  return (
    <div className={className}>
      <button type="button" className={classes.headerButton} onClick={toggleOpen}>
        <span className={classes.title}>{title}</span>
        {Icon}
      </button>
      <Collapse in={isOpen} unmountOnExit>
        <div className={classes.content}>{children}</div>
      </Collapse>
    </div>
  );
};

export { Accordion };
